import { ApplicationsDropdownWrapperMobile } from '../ApplicationsDropdownWrapper/ApplicationsDropdownWrapperMobile';
import { ApplicationsDropdownInlineButton } from './ApplicationsDropdownInlineTrigger';

export const ApplicationsDropdownInlineTriggerMobile = () => <ApplicationsDropdownWrapperMobile trigger={<ApplicationsDropdownInlineButton />} />;
